export default {
  "b2b.zdroje-grid.title": "Zdroje",
  "b2b.zdroje-grid.add": "Přidat zdroj"
};
